export default {"src":"/_next/static/media/ic-tiktok-colorized.ce187413.svg","height":14,"width":14};